
import { defineComponent } from 'vue'
import { FilterMatchMode } from 'primevue/api'
import rgpdService from '@/services/rgpd.service'
import moment from 'moment'

interface RGPDFileData {
  file_url?: string
  label?: string
  label_building?: string
  address_building?: string
  creation_date?: number
  stringdate?: string
}

export default defineComponent({
  data() {
    return {
      rgpdFiles: [] as RGPDFileData[],
      filters: {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS }
      },
      loading: false
    }
  },
  methods: {
    async downloadFile(file_url: string, label: string) {
      try {
        const url: string = file_url!
        const response = await rgpdService.downloadFile(url)
        return response
      } catch (error) {
        console.log('Download file error', error)
      }
    },
    onNewDemandButtonClick(event: Event) {
      rgpdService
        .getUserData()
        .then((res: any) => {
          this.$toast.add({
            severity: 'success',
            summary: 'La demande a été prise en compte',
            detail: 'Veuillez consulter votre boîte mail',
            life: 6000
          })
        })
        .catch((err) => {
          console.log(err)
          this.$toast.add({
            severity: 'error',
            summary: "Une erreur s'est produite",
            detail: err.response.data.message,
            life: 3000
          })
        })
    }
  },
  computed: {
    userData(): number {
      return this.rgpdFiles.filter((a) => a.label?.includes('utilisateur')).length
    },
    buildingdata(): number {
      return this.rgpdFiles.filter((a) => a.label?.includes('Données des capteurs')).length
    }
  },
  async mounted() {
    this.loading = true
    const response = await rgpdService.getUserDataFiles()
    this.rgpdFiles = response.data
    this.rgpdFiles.forEach((f) => {
      const creation: number = f.creation_date as number
      f.stringdate = moment.unix(creation / 1000)?.format('DD/MM/YYYY HH:mm:ss')
    })
    this.loading = false
  }
})
